import {
    inboxWorkflowColumn,
    inboxWorkflowPartialMessage,
    type InboxWorkflowCellComponent,
    type InboxWorkflowJson,
    type InboxWorkflowTableStepConfig,
} from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
import SourceCleanupCompletionCell from "../../../../_shared/_modules/source-cleanup-completion-cell"
import SourceCleanupPreconfiguration from "../../../../_shared/_modules/source-cleanup-preconfiguration"
import WrongRecipientSourceCleanupCell from "./_modules/wrong-recipient-source-cleanup-cell"
import WrongRecipientSourceCleanupCustomerCell from "./_modules/wrong-recipient-source-cleanup-customer-cell"
import WrongRecipientSourceCleanupPropertyCell from "./_modules/wrong-recipient-source-cleanup-property-cell"
import WrongRecipientSourceCleanupSourceCell from "./_modules/wrong-recipient-source-cleanup-source-cell"
import type { WrongRecipientSourceCleanupDraft, WrongRecipientSourceCleanupRow } from "./contract"
import { buildWrongRecipientSourceCleanupRows } from "./_logic/tableRows"

export const wrongRecipientSourceCleanupCells: Record<string, InboxWorkflowCellComponent> = {
  wrongRecipientCleanupCompletion: SourceCleanupCompletionCell,
  wrongRecipientCleanupCustomer: WrongRecipientSourceCleanupCustomerCell,
  wrongRecipientCleanupInstructions: WrongRecipientSourceCleanupCell,
  wrongRecipientCleanupProperty: WrongRecipientSourceCleanupPropertyCell,
  wrongRecipientCleanupSource: WrongRecipientSourceCleanupSourceCell,
}

export const createWrongRecipientSourceCleanupStep = (): InboxWorkflowTableStepConfig<
  WrongRecipientSourceCleanupRow,
  WrongRecipientSourceCleanupDraft,
  InboxWorkflowJson
> => ({
  kind: "table",
  columns: [
    inboxWorkflowColumn(
      "sourceInstructions",
      "Im Kehrbezirksprogramm erledigen",
      "wrongRecipientCleanupInstructions",
    ),
    inboxWorkflowColumn(
      "completion",
      "Im Kehrbezirksprogramm nachgetragen?",
      "wrongRecipientCleanupCompletion",
    ),
    inboxWorkflowColumn("sourceLabel", "Herkunft", "wrongRecipientCleanupSource"),
    inboxWorkflowColumn("addressLabel", "Liegenschaft", "wrongRecipientCleanupProperty"),
    inboxWorkflowColumn(
      "customerLabel",
      "Falscher Ansprechpartner",
      "wrongRecipientCleanupCustomer",
      {
        isPrimary: true,
      },
    ),
  ],
  buildRows: ({ workflow, step, rowOutcomes }) =>
    buildWrongRecipientSourceCleanupRows({ workflow, step, rowOutcomes }),
  draft: {
    create: (row) => ({ completed: row.completed }),
    validate: (_row, draft) =>
      draft.completed
        ? null
        : "Bitte markieren Sie jede offene Zeile als im Kehrbezirksprogramm erledigt.",
  },
  preconfiguration: SourceCleanupPreconfiguration,
  buildPayload: () => ({}),
  commit: {
    label: "Nachtrag erledigt markieren",
    successMessage: "Nachtrag wurde als erledigt markiert.",
    partialMessage: inboxWorkflowPartialMessage,
  },
})
